import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { checkFilterItem, fetchFilterData } from "../../../../../utils/fetchFilterData";
import ItemsPerPageSelect from "../../../../elements/filter/ItemsPerPageSelect";
import MaterialPagination from "../../../../styles/materialPagination";
import userAuthenticationConfig from "../../../../../utils/userAuthenticationConfig";
import Notification from "../../../../elements/notification/Notification";
import ProjectList from "./ProjectList";
import ProjectsFilter from "../../../../projects/client/ProjectsFilter";
import FilterAppliedList from "../../../../elements/filter/FilterAppliedList";
import { itemsPerPageValue } from "../../../../../utils/ItemsPerPageValue";

const ProjectContainer = ({ match }) => {

  const [supportUserProjects, setSupportUserProjects] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);
  const [refetch, setRefetch] = useState(false);

  const userId = match.params.id;

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "projects", false, true),
    "name": checkFilterItem(history, "name", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchProjectsList = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/projects/get-enable-project-by-user-support-projects/" + userId + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setSupportUserProjects(response.data["projects"]);
        setTotalPageCount(response.data.totalPageCount);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  useEffect(() => {
    fetchProjectsList();
  }, [filterData, refetch]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <div className="content-head">
        <ProjectsFilter
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <ItemsPerPageSelect
          itemsPerPage={filterData.itemsPerPage}
          setItemsPerPage={(data) => setFilterData({
            ...filterData,
            "itemsPerPage": data,
            page: 1
          })}
        />
      </div>
      <FilterAppliedList
        filterData={filterData}
        setFilterData={setFilterData}
      />
      <ProjectList
        userProjects={supportUserProjects}
        userId={userId}
        notification={notification}
        setNotification={setNotification}
        refetch={refetch}
        setRefetch={setRefetch}
      />
      {totalPageCount > 0 &&
        <MaterialPagination
          count={totalPageCount}
          shape="rounded"
          page={filterData.page}
          onChange={(event, page) => onChangePage(event, page)}
        />}
    </>
  );
};

export default ProjectContainer;